/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceOverviewSchema } from '../models/InvoiceOverviewSchema';
import type { LessonEditIn } from '../models/LessonEditIn';
import type { SimpleLessonOut } from '../models/SimpleLessonOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class Fm3Service {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Redirect Oauth Exact Online
   * @param apiKey
   * @param code
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFm3RedirectOauthExactOnline(apiKey: string, code: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/redirect_oauth/exactonline/{api_key}',
      path: {
        api_key: apiKey,
      },
      query: {
        code: code,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Redirect Oauth
   * @param slackLoginToken
   * @returns void
   * @throws ApiError
   */
  public getFm3RedirectOauth(slackLoginToken: string): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/redirect_oauth/oath2_redirect',
      query: {
        slack_login_token: slackLoginToken,
      },
      errors: {
        307: `Successful Response`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Lesson Complete
   * ### Get the lesson
   *
   * Args:
   * - lesson_id `int`: The lesson_id of the lesson to get
   *
   * Permissions:
   * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
   *
   * Returns:
   * - The lesson
   * @param lessonId
   * @returns SimpleLessonOut Successful Response
   * @throws ApiError
   */
  public getFm3GetLessonComplete(lessonId: number): CancelablePromise<SimpleLessonOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/lessons/lesson/{lesson_id}/complete',
      path: {
        lesson_id: lessonId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Lesson Complete
   * ### Update the lesson with the force_pay status
   *
   * Args:
   * - lesson_id `int`: The lesson_id of the lesson to update
   * - lesson_edit `LessonEdit`: The lesson edit object with the force_pay status
   *
   * Permissions:
   * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
   *
   * Returns:
   * - The lesson
   *
   * Raises:
   * - 400: If the lesson is not cancelled
   * - 422: If the start time is after the end time
   * @param lessonId
   * @param requestBody
   * @returns SimpleLessonOut Successful Response
   * @throws ApiError
   */
  public patchFm3UpdateLessonComplete(
    lessonId: number,
    requestBody: LessonEditIn
  ): CancelablePromise<SimpleLessonOut> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/fm3/lessons/lesson/{lesson_id}/complete',
      path: {
        lesson_id: lessonId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Invoice
   * @param invoiceId
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFm3RetryInvoice(invoiceId: number): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fm3/invoices/retry/{invoice_id}',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Successful Invoices
   * ### Get all successful invoices in descending order
   *
   * Returns:
   * - All successful invoices in descending order
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetSuccessfulInvoices(): CancelablePromise<Array<InvoiceOverviewSchema>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/invoices/invoicing/successful',
    });
  }
  /**
   * Get Failed Invoices
   * ### Get all failed invoices in descending order
   *
   * Returns:
   * - All failed invoices in descending order
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetFailedInvoices(): CancelablePromise<Array<InvoiceOverviewSchema>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/invoices/invoicing/failed',
    });
  }
  /**
   * Get Invoice By Id
   * ### Get a specific invoice by id
   *
   * Args:
   * - invoice_id (int): The id of the invoice to get
   *
   * Returns:
   * - The invoice with the given id
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @param invoiceId
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetInvoiceById(invoiceId: number): CancelablePromise<InvoiceOverviewSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/fm3/invoices/invoicing/invoice/{invoice_id}',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Failed Invoice By Id
   * ### Force retry a failed invoice
   *
   * Args:
   * - invoice_id (int): The id of the invoice to retry
   *
   * Returns:
   * - The result of the retry action
   *
   * Raises:
   * - HTTPException.status 400: If there is something wrong with the invoice, and not with the data its built from
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @param invoiceId
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFm3RetryFailedInvoiceById(invoiceId: number): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/fm3/invoices/invoicing/invoice/{invoice_id}/retry',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Redirect Oauth Exact Online
   * @param apiKey
   * @param code
   * @returns any Successful Response
   * @throws ApiError
   */
  public getFm3RedirectOauthExactOnlineVLatest(
    apiKey: string,
    code: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/redirect_oauth/exactonline/{api_key}',
      path: {
        api_key: apiKey,
      },
      query: {
        code: code,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Redirect Oauth
   * @param slackLoginToken
   * @returns void
   * @throws ApiError
   */
  public getFm3RedirectOauthVLatest(slackLoginToken: string): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/redirect_oauth/oath2_redirect',
      query: {
        slack_login_token: slackLoginToken,
      },
      errors: {
        307: `Successful Response`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Lesson Complete
   * ### Get the lesson
   *
   * Args:
   * - lesson_id `int`: The lesson_id of the lesson to get
   *
   * Permissions:
   * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
   *
   * Returns:
   * - The lesson
   * @param lessonId
   * @returns SimpleLessonOut Successful Response
   * @throws ApiError
   */
  public getFm3GetLessonCompleteVLatest(lessonId: number): CancelablePromise<SimpleLessonOut> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/lessons/lesson/{lesson_id}/complete',
      path: {
        lesson_id: lessonId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Lesson Complete
   * ### Update the lesson with the force_pay status
   *
   * Args:
   * - lesson_id `int`: The lesson_id of the lesson to update
   * - lesson_edit `LessonEdit`: The lesson edit object with the force_pay status
   *
   * Permissions:
   * - `edit_force_pay`: The permission to edit the force_pay status of the lesson
   *
   * Returns:
   * - The lesson
   *
   * Raises:
   * - 400: If the lesson is not cancelled
   * - 422: If the start time is after the end time
   * @param lessonId
   * @param requestBody
   * @returns SimpleLessonOut Successful Response
   * @throws ApiError
   */
  public patchFm3UpdateLessonCompleteVLatest(
    lessonId: number,
    requestBody: LessonEditIn
  ): CancelablePromise<SimpleLessonOut> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/latest/fm3/lessons/lesson/{lesson_id}/complete',
      path: {
        lesson_id: lessonId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Invoice
   * @param invoiceId
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFm3RetryInvoiceVLatest(invoiceId: number): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fm3/invoices/retry/{invoice_id}',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Successful Invoices
   * ### Get all successful invoices in descending order
   *
   * Returns:
   * - All successful invoices in descending order
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetSuccessfulInvoicesVLatest(): CancelablePromise<Array<InvoiceOverviewSchema>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/invoices/invoicing/successful',
    });
  }
  /**
   * Get Failed Invoices
   * ### Get all failed invoices in descending order
   *
   * Returns:
   * - All failed invoices in descending order
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetFailedInvoicesVLatest(): CancelablePromise<Array<InvoiceOverviewSchema>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/invoices/invoicing/failed',
    });
  }
  /**
   * Get Invoice By Id
   * ### Get a specific invoice by id
   *
   * Args:
   * - invoice_id (int): The id of the invoice to get
   *
   * Returns:
   * - The invoice with the given id
   *
   * Raises:
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @param invoiceId
   * @returns InvoiceOverviewSchema Successful Response
   * @throws ApiError
   */
  public getFm3GetInvoiceByIdVLatest(invoiceId: number): CancelablePromise<InvoiceOverviewSchema> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/latest/fm3/invoices/invoicing/invoice/{invoice_id}',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Failed Invoice By Id
   * ### Force retry a failed invoice
   *
   * Args:
   * - invoice_id (int): The id of the invoice to retry
   *
   * Returns:
   * - The result of the retry action
   *
   * Raises:
   * - HTTPException.status 400: If there is something wrong with the invoice, and not with the data its built from
   * - HTTPException.status 403: If the user does not have the rights to retry invoices
   * @param invoiceId
   * @returns any Successful Response
   * @throws ApiError
   */
  public postFm3RetryFailedInvoiceByIdVLatest(invoiceId: number): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/latest/fm3/invoices/invoicing/invoice/{invoice_id}/retry',
      path: {
        invoice_id: invoiceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
